import apiClient, { attachAuthToken } from "./apiClient";

const API_URL = process.env.REACT_APP_API_BASE_URL
const CACHE_PREFIX = "downloadCache_";
const EXPIRY_MS = 15 * 60 * 1000; // 10 min


export const uploadFile = async (file, auth, expiresIn = 10, keepForever= false) => {
  try {
    const token = auth?.user?.id_token;
    if (!token) throw new Error("User not authenticated");

    const uploadUrl = `?fileName=${encodeURIComponent(file.name)}&expiresIn=${encodeURIComponent(expiresIn)}&keepForever=${encodeURIComponent(keepForever)}`;

    const response = await apiClient.post(uploadUrl, file, {
      headers: {
        "Content-Type": "application/octet-stream",
        Authorization: `Bearer ${token}`,
      },
    });    
    return response.data;
  } catch (error) {
    console.error("Upload failed:", error);
    throw new Error("Upload failed. Please try again.");
  }
};

export const downloadFile = async (shareId, auth) => {
  const cacheKey = `${CACHE_PREFIX}${shareId}`;

  const cached = localStorage.getItem(cacheKey);
  if (cached) {
    const parsed = JSON.parse(cached);
    const now = Date.now();

    if (now < parsed.expiry) {
      const remainingMs = parsed.expiry - now;
      const expiresIn = Math.ceil(remainingMs / 60000);

      return { ...parsed.data, expiresIn };
    } else {
      localStorage.removeItem(cacheKey);
    }
  }

  attachAuthToken(auth);
  const apiUrl = `${API_URL}?shareId=${encodeURIComponent(shareId)}`;

  try {
    const response = await apiClient.get(apiUrl);
    const data = response.data;

    if (!data.downloadUrl) {
      throw new Error("Presigned URL not found in response");
    }

    const expiryTimestamp = Date.now() + EXPIRY_MS;

    const result = {
      fileName: data.fileName || shareId,
      downloadUrl: data.downloadUrl,
      expiresIn: Math.ceil(EXPIRY_MS / 60000)
    };

    localStorage.setItem(
      cacheKey,
      JSON.stringify({
        expiry: expiryTimestamp,
        data: {
          fileName: result.fileName,
          downloadUrl: result.downloadUrl
        }
      })
    );

    return result;

  } catch (err) {
    console.error("Download failed:", err);
    throw err;
  }
};


export const getSavedFiles = async () => {
  try {
    const response = await apiClient.get(API_URL); 
    if (response?.data?.files) {
      return response.data.files;
    } else {
      console.warn("Unexpected response format:", response.data);
      return [];
    }
  } catch (error) {
    console.error("Error fetching saved files:", error);
    throw error;
  }
};